/**
 * Maps validation issue codes to user-facing copy (retake sheet).
 * @param {import('../types').ValidationIssue[]} issues
 * @returns {string[]}
 */
export function issuesToUserMessages(issues) {
  const seen = new Set();
  const out = [];
  for (const i of issues) {
    if (i.severity === 'warning' && issues.some((x) => x.severity === 'error')) {
      continue;
    }
    if (seen.has(i.code)) continue;
    seen.add(i.code);
    out.push(i.message);
  }
  return out.length ? out : ['Please adjust and retake the photo.'];
}
